// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3vQCz","productName":"Table_productName__3W7u5"};